export default "__VITE_ASSET__DyX2It1e__"